import RestAPI from '../../components/Common/restApi';

export default class ProApi {
  static fetchProExperiments() {
    return RestAPI.get('/api/v2/pro/experiments');
  }

  static createProExperiment(formData) {
    return RestAPI.postWithFormData('/api/v2/pro/experiments', formData);
  }

  static fetchPro() {
    return RestAPI.get('/alpha/pro');
  }

  static updatePro(form_data) {
    return RestAPI.updateWithFormData('/alpha/pro', form_data);
  }

  static index() {
    return RestAPI.get('/alpha/pros');
  }
}
